<template>
    <div class="row justify-content-between py-5 ">
    
        <div class="col-12 mb-3" v-if="running">
            <div class="progress">
                <div class="progress-bar bg-success progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
            </div>
        </div>
        <div class="col-6 col-lg-2 py-1 text-left">
            <router-link :to="{name: linkBack}" class="btn btn-outline-primary btn-lg btn-block px-5 d-flex align-items-center justify-content-center" v-if="linkBack">
                <i class="fa fa-arrow-left mr-3"></i> Back
            </router-link>
        </div>
<!--        <div class="col-6 col-lg-2 py-1 text-center">-->
<!--            <button class="btn btn-outline-primary btn-lg btn-block px-3 d-flex align-items-center justify-content-center">-->
<!--                Save & exit-->
<!--            </button>-->
<!--        </div>-->
        <div class="col-6 col-lg-2 py-1 text-right">
            <router-link :to="{name: linkNext}" class="btn btn-success btn-success-gradient btn-lg btn-block px-5 d-flex align-items-center justify-content-center" v-if="linkNext">
                Next
            </router-link>
        </div>
    
    </div>
</template>

<script>
import {EventBus, events} from "@/utils/event-bus";

export default {
        name: "BottomNavigation",
        data() {
            return {
                running: false
            }
        },
        computed: {
            linkBack: function () {
                if(this.$route.name === 'SetupHome'){
                    return false;
                }
                if(this.$route.name === 'SetupCurrent'){
                    return 'SetupHome';
                }
                if(this.$route.name === 'SetupEnergy'){
                    return 'SetupCurrent';
                }

                return 'SetupEnergy';

            },
            linkNext: function () {
                if(this.$route.name === 'SetupHome'){
                    return 'SetupCurrent';
                }
                if(this.$route.name === 'SetupCurrent'){
                    return 'SetupEnergy';
                }
                if(this.$route.name === 'SetupEnergy'){
                    return 'SetupDeal';
                }

                return false;
            }
        },
        beforeRouteLeave: function (to, from, next){
            if(to.name === 'SetupDeal'){
                this.running = true
            }
            next()
        },
        mounted() {
            let that = this;
            EventBus.$on(events.survey.error, function (){
                that.$toast.error('Problem with submitting your details!')
                that.running = false
            })
        },
        destroyed() {
            EventBus.$off(events.survey.error)
        }
}
</script>

<style scoped lang="scss">
    button, a {
        min-height: 50px;
    }
</style>
